import {
  BottomSheetComponent,
  NavigationConfig,
  ParamListBase,
  registerBottomSheets,
  registerNavigationHandlers,
  hideHeader,
  Modal,
} from '@bonanza-social/navigation';
import { PromoDetailsScreenParams } from '../screens/PromoDetailsScreen/PromoDetailsScreen.types';
import PromosScreen from '../screens/PromosScreen';
import PromoDetailsScreen from '../screens/PromoDetailsScreen/PromoDetailsScreen';
import OptedInPromo from './bottomsheets/OptedInPromo/OptedInPromo';
import OptOutPromo from './bottomsheets/OptOutPromo/OptOutPromo';
import ReferrerPromoScreen from '../screens/ReferrerPromoScreen';
import SmarticoPromoScreen from '../screens/SmarticoPromoScreen/SmarticoPromoScreen';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [
    {
      name: 'Promos',
      options: { headerShown: true },
      component: PromosScreen,
    },
    {
      name: 'PromoDetails',
      options: { headerShown: true },
      component: PromoDetailsScreen,
    },
    {
      name: 'ReferrerPromoScreen',
      options: { headerShown: true },
      component: ReferrerPromoScreen,
    },
  ],
  FULL_SCREEN_MODALS: [
    {
      name: 'SmarticoPromo',
      options: hideHeader,
      component: SmarticoPromoScreen,
    },
  ],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const bottomSheets = {
  OptedInPromo,
  OptOutPromo,
};

registerBottomSheets('promos', bottomSheets);

registerNavigationHandlers<
  AppNavigatorParamsList,
  'Promos' | 'PromoDetails' | 'SmarticoPromo'
>({
  Promos(navigate) {
    navigate('/promos');
  },
  PromoDetails(navigate, params) {
    if (!params) {
      return;
    }
    const { id } = params;
    navigate(`/promos/${id}`);
  },
  SmarticoPromo(_navigate, params) {
    if (!params?.url) {
      return;
    }

    Modal.open({
      namespace: 'promos',
      type: 'SmarticoPromo',
      data: {
        url: params.url,
      },
      options: {
        hideHeader: true,
      },
      style: {
        width: '100%',
        height: '100%',
        borderRadius: 'radius-400',
      },
    });
  },
});

declare global {
  interface RegisteredBottomSheets {
    promos: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}

declare global {
  interface AppNavigatorParamsList extends ParamListBase {
    Promos: undefined;
    PromoDetails: PromoDetailsScreenParams;
    SmarticoPromo: { url: string; title?: string };
  }
}
